import styled from 'styled-components';
import { Stack } from '@karma/components';
import { getColor } from '@karma/components/colors';

export const Container = styled(Stack).attrs({
  spacing: 4,
})`
  height: 20px;
  padding: 0 4px;
  border-radius: 2px;
  background: ${getColor('color15')};
`;
